import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/pro-solid-svg-icons';

import ManagedInput from 'components/form/managed_input';
import PropertySubtypes from './property_subtypes';

export default function CompanyGridPropertyType({ propertyType, onChange }) {
  const [expanded, setExpanded] = useState();

  function changeEnabled(enabled) {
    setExpanded(enabled);
    onChange({
      ...propertyType,
      enabled,
      subtypesById: setEnabledForAllSubtypes(enabled),
    });
  }

  function handleSubtypeChange(subtype) {
    const changes = {
      ...propertyType,
      subtypesById: {
        ...propertyType.subtypesById,
        [subtype.id]: subtype,
      },
    };

    changes.enabled = Object.values(changes.subtypesById).some(subtype => subtype.enabled);

    onChange(changes);
  }

  function setEnabledForAllSubtypes(enabled) {
    const subtypesById = {};
    for (const id in propertyType.subtypesById) {
      subtypesById[id] = { ...propertyType.subtypesById[id], enabled };
    }

    return subtypesById;
  }

  function toggleExpanded(event) {
    event.preventDefault();
    setExpanded(!expanded);
  }

  const { enabled, label } = propertyType;
  return (
    <div className={classNames('property-type', { enabled })}>
      <div className="d-flex align-items-center gap-2">
        <ManagedInput
          checked={enabled}
          name="enabled"
          type="checkbox"
          onValueChange={changeEnabled}
        >
          {label}
        </ManagedInput>

        <div className="clickable" name="expand" onClick={toggleExpanded}>
          <FontAwesomeIcon icon={expanded ? faChevronDown : faChevronRight} size="sm" />
        </div>
      </div>

      {expanded && (
        <PropertySubtypes
          propertyType={propertyType}
          onChange={handleSubtypeChange}
        />
      )}
    </div>
  );
}

CompanyGridPropertyType.propTypes = {
  propertyType: PropTypes.shape({
    enabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
